<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableNatGatewayResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.AWS.Gateway.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t('RAM.AWS.natGateway.region'),
          key: "region"
        },
        {
          title: this.$t('RAM.AWS.natGateway.name'),
          key: "name"
        },
        {
          title: this.$t('RAM.AWS.natGateway.natGatewayId'),
          key: "natGatewayId"
        },
        {
          title: this.$t('RAM.AWS.natGateway.status'),
          key: "state"
        },
        {
          title: this.$t('RAM.AWS.natGateway.elasticIpAddress'),
          key: "publicIp"
        },
        {
          title: this.$t('RAM.AWS.natGateway.privateIpAddress'),
          key: "privateIp"
        },
        {
          title: this.$t('RAM.AWS.natGateway.networkInterfaceId'),
          key: "networkInterfaceId"
        },
        {
          title: "VPC",
          key: "vpcId"
        },
        {
          title: this.$t('RAM.AWS.natGateway.subnet'),
          key: "subnetId"
        },
        {
          title: this.$t('RAM.AWS.natGateway.creationTime'),
          key: "createTime"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountIds", function(val) {
      tableDataVue.accountIds = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("natGatewayId", function(val) {
      tableDataVue.natGatewayId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .pagingQueryAWSNatGateway({
          companyId: tableDataVue.companyId,
          accountIdList: tableDataVue.accountIds,
          accountName: tableDataVue.accountName,
          natGatewayId: tableDataVue.natGatewayId,
          pageNum: this.current,
          pageSize: this.pageSize,
          accountType: 0
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("accountIds");
      eventBus.$off("accountName");
      eventBus.$off("natGatewayId");
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/nat_gateway/TableNatGatewayResource.vue